// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topology-selection-wrapper[data-v-01afb890] {\n  border: 1px solid #bed1da;\n  border-right: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
